<template>
  <div class="Order">
    <img class="Order__img" src="../assets/images/bottles.png" alt="" />
    <div class="Order__main">
      <div class="Order__quantity">{{ quantity }} {{ "article" | pluralize(quantity) }}</div>
      <div class="Order__date">
        {{ order_date | dateFormat }}
      </div>
    </div>
    <Price class="Order__price" :price="price" />
  </div>
</template>

<script>

export default {
  props: {
    order_date: {
      type: String,
      required: true
    },
    quantity: {
      type: Number,
      required: true
    },
    price: {
      type: Number,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/variables";

.Order {
  display: flex;
  align-items: center;
  background-color: #fff;
  border-bottom: 1px solid $color-smoke;
  padding: $global-margin;

  &__main {
    padding: 0 $global-margin;
    font-size: 0.85rem;
  }

  &__quantity {
    font-weight: 700;
  }

  &__date {
    color: $color-grey;
  }

  &__price {
    margin-left: auto;
  }
}
</style>
